import React from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';
import kebabCase from 'lodash/kebabCase';
import themeStyles from '../VehicleListFilters.styles';
const SectionWrapper = themeStyles.apply(Box, 'SectionWrapper');
const SectionTitle = themeStyles.apply(Copy, 'SectionTitle');
const FilterItemsWrapper = themeStyles.apply(Box, 'FilterItemsWrapper');
const FiltersSection = ({ filterOption, ItemComponent }) => {
    const { title, options } = filterOption;
    const formattedTitleTestId = kebabCase(title);
    const hasImages = options.some(option => option.icon.src);
    return (React.createElement(SectionWrapper, { "data-testid": `cy-${formattedTitleTestId}-section` },
        React.createElement(SectionTitle, { "data-testid": `cy-${formattedTitleTestId}-section-title`, size: "small" }, title),
        React.createElement(FilterItemsWrapper, { hasImages: hasImages }, options.map(item => (React.createElement(ItemComponent, { key: item.key, item: item, parentTestId: formattedTitleTestId }))))));
};
export default FiltersSection;
